export default __webpack_public_path__ + "static/web-site-top-mobile-448f505d008a454db983e57634d038b4.jpg";